import { catchError, EMPTY, mergeMap } from "rxjs"
import { ACTION_TYPES } from "../actions/types"
import { ofType } from "redux-observable"
import { Service } from "../services/service"
import { Action } from "../actions/actions"
import { InventoryStockDocumentDefinitionSelector } from "../selectors"

export const fetchListingEpic = (action$, state$) => {
    return action$.pipe(
        ofType(ACTION_TYPES.FETCH_LISTING),
        mergeMap(() => {
            const status = InventoryStockDocumentDefinitionSelector.getApiStatus(state$.value)
            if (status.isLoaded) {
                return EMPTY
            }
            return Service.fetchAll()
                .then(response => {
                    return Action.fetchListingSuccess(response)
                })
        }),
        catchError(() => EMPTY)
    )
}



// WEBPACK FOOTER //
// ./src/state/inventory/stockDocumentDefinition/epics/epics.ts